import React, { useState } from "react";
import { IP } from "../../../../internalServer";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../../HwManagement/PdfViewer/PdfViewer";
import ZoomableImage from "../../../../HwManagement/HomeWork/Pending/QuestionTypes/ZoomableImage";

const getFileType = (fileUrl) => {
  if (!fileUrl || typeof fileUrl !== "string") return "";
  const parts = fileUrl.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

export default function CheckBoxType({
  response,
  questionNo,
  isAdaptiveCheck,
}) {
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickforpdf = (fileUrl) => {
    setTimeout(() => {
      setResponseAttach(fileUrl);
      setMideaviewer(true);
    }, 100);
  };

  return (
    <>
      {response && (
        <div className="containerBelowQuestion">
          {/* Title */}
          <div className="mb-5">
            <div className="text-[16px] font-semibold text-slate-800 leading-relaxed">
              Q{questionNo}.{" "}
              {response?.question_response?.question?.title
                ?.split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {index !== 0 && <br />}
                    <span
                      style={
                        index !== 0
                          ? { marginLeft: "30px", display: "inline-block" }
                          : {}
                      }
                    >
                      {line}
                    </span>
                  </React.Fragment>
                ))}
              {response?.question_response?.question?.is_mandatory && (
                <span className="inline-block ml-3 px-2 py-0.5 rounded bg-red-50 text-red-700 text-[10px] font-bold uppercase tracking-wide border border-red-200">
                  * Mandatory
                </span>
              )}
            </div>
          </div>

          {/* Options */}
          <div
            className="mt-4 space-y-3"
            style={{ width: isAdaptiveCheck ? "87%" : "100%" }}
          >
            {response?.question_response?.question?.options?.map((option) => {
              const isStudentAnswer =
                response?.question_response?.answer?.key === option?.key;
              const isCorrectAnswer =
                response?.question_response?.question?.correct_answers?.some(
                  (c) => c.option_key === option?.key,
                );

              // Teacher-style box colors
              let containerClass = "border-slate-200 bg-white";
              let textClass = "text-slate-700";
              let iconContainerClass = "border-slate-300 bg-white";

              if (isCorrectAnswer) {
                containerClass = "border-emerald-500 bg-emerald-50/50";
                textClass = "text-emerald-900 font-semibold";
                iconContainerClass = "border-emerald-500 bg-emerald-500";
              } else if (isStudentAnswer && !isCorrectAnswer) {
                containerClass = "border-red-500 bg-red-50/50";
                textClass = "text-red-900 font-semibold";
                iconContainerClass = "border-red-500 bg-red-500";
              }

              return (
                <div
                  key={option?.key}
                  className={`flex items-center justify-between px-4 py-3 rounded-xl border-[1.5px] transition-all ${containerClass}`}
                >
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-5 h-5 rounded flex items-center justify-center border-2 ${iconContainerClass}`}
                    >
                      {(isCorrectAnswer || isStudentAnswer) && (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M5 13L9 17L19 7"
                            stroke="#fff"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <span className={`text-sm ${textClass}`}>
                      {option?.key}. {option?.value}
                    </span>
                  </div>

                  {/* Badges */}
                  <div className="flex gap-2">
                    {isCorrectAnswer && (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-emerald-600 text-white text-[11px] font-semibold shadow-sm">
                        Correct Answer
                      </span>
                    )}
                    {isStudentAnswer && (
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-red-600 text-white text-[11px] font-semibold shadow-sm">
                        Student Answer
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Status: Correct / Wrong */}
          <div className="mt-6">
            {response?.question_response?.answer?.key === " " ? (
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-orange-50 border border-orange-200 text-orange-700">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M12 8V12M12 16H12.01"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="text-sm font-semibold">
                  Student Not Answered
                </span>
              </div>
            ) : response?.question_response?.question?.correct_answers?.some(
                (c) =>
                  c.option_key === response?.question_response?.answer?.key,
              ) ? (
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M8 12L11 15L16 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-sm font-semibold">Correct Answer</span>
              </div>
            ) : (
              <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M15 9L9 15M9 9L15 15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <span className="text-sm font-semibold">Wrong Answer</span>
              </div>
            )}
          </div>

          {/* Evaluation Comment (AI + Teacher) */}
          {!isAdaptiveCheck && (
            <div className="mt-6 p-4 rounded-xl bg-slate-50 border border-slate-200">
              <div className="flex items-center gap-2 mb-2">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="text-indigo-500"
                >
                  <path
                    d="M12 2L14.5 9H21L15.5 13L17.5 20L12 16L6.5 20L8.5 13L3 9H9.5L12 2Z"
                    fill="currentColor"
                    opacity="0.2"
                  />
                  <path
                    d="M12 2L14.5 9H21L15.5 13L17.5 20L12 16L6.5 20L8.5 13L3 9H9.5L12 2Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-[11px] font-bold text-indigo-600 uppercase tracking-wider">
                  Evaluation Comment
                </span>
              </div>
              <div className="text-sm text-slate-700 leading-relaxed">
                {response?.evaluation_explanation ||
                  response?.comment ||
                  "No evaluation comment available."}
              </div>
            </div>
          )}
        </div>
      )}

      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}

      {isClicked &&
        responseAttach &&
        (responseAttach.split(".").pop().toLowerCase() === "mp4" ? (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue cursor-pointer"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Close"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={() => setIsError(true)}
                  />
                  <div>
                    <img
                      className="crossIconImgQue cursor-pointer"
                      onClick={() => {
                        handleClick();
                        setIsError(false);
                      }}
                      src="/images/cross.png"
                      alt="Close"
                    />
                  </div>
                </>
              ) : (
                <div className="fullSizeImg flex flex-col items-center justify-center">
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Close"
                    className="cursor-pointer absolute top-[75px] right-[40%]"
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    className="w-1/4"
                  />
                  <p className="text-red-500 text-lg font-medium mt-4">
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}
    </>
  );
}
